import React from 'react'
import { Loader } from '@tumelo/shared'

export const LoadingForm: React.FC = () => <Loader />
